import Vue from 'vue'

//export const EventBus = new Vue()
//let EventBus = new Vue()
//export default EventBus

const EventBus = new Vue()
export default EventBus

